module.exports = __webpack_public_path__ + "static/img/godwealth2_en.9f4cdcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/godwealth2_en.png
// module id = faPu
// module chunks = 1